export const setTourState = (state, action): any => {
  const updatedState = {
    ...state,
    isTour: action.payload.isTour,
  };

  return updatedState;
};
